<template>
  <vs-row>
    <vs-row class="my-5 mx-4">
      <vs-col vs-lg="6" vs-sm="12">
        <vs-row>
          <vs-button
            class="pr-15 mr-4"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addNewData"
            >Add New</vs-button
          >
          <vs-button
            :disabled="selected.length <= 0"
            class="pl-8 ml-4 font-semibold center"
            type="filled"
            :color="actionBtnClr"
            @click="confirmDelete = true"
            >Delete</vs-button
          >
        </vs-row>
      </vs-col>
      <vs-col vs-lg="1" vs-sm="0"></vs-col>
      <vs-col vs-lg="5" vs-sm="12">
        <vs-row vs-type="flex" vs-justify="flex-end">
          <input
            maxLength="30"
            type="text"
            name="search"
            class="search px-4 w-1/3 py-3 shadow-lg"
            placeholder="Search..."
            @input="getOfferCards('search')"
            v-model="search"
          />
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row class="tblBgClrPending shadow-lg mx-4">
      <vs-table
        id="table1"
        multiple
        v-model="selected"
        :max-items="itemsPerPage"
        :data="offersCardsList"
        class="w-full"
        hoverFlat
      >
        <template slot="thead">
          <vs-th> IMAGE</vs-th>
          <vs-th class="th-left-aligned" sort-key="popularity">
            CREDIT CARD NAME
          </vs-th>
          <vs-th sort-key="order_status">BONUS</vs-th>
          <vs-th sort-key="order_status">EMOJI</vs-th>
          <vs-th sort-key="order_status">EXPIRATION DATE</vs-th>
          <vs-th sort-key="order_status">Hide from Dashboard</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr
              vs-align="center"
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >
              <vs-td
                class="img-container center"
                @click.native.stop="reviewData(tr)"
              >
                <vue-load-image>
                  <img
                    slot="image"
                    :src="
                      tr.card.photo
                        ? $ApiKeys.BASE_URL + tr.card.photo
                        : require('@/assets/images/default-images/default-profile.png')
                    "
                    width="77"
                    height="48"
                  />
                  <img
                    slot="preloader"
                    src="@/assets/images/image-loader.gif"
                    width="77"
                    height="77"
                  />
                  <div slot="error">
                    <img
                      slot="image"
                      :src="require('@/assets/images/no_preview.jpg')"
                      width="77"
                      height="48"
                    />
                  </div>
                </vue-load-image>
              </vs-td>

              <vs-td @click.native.stop="reviewData(tr)">
                <p class="font-medium">
                  {{ tr.card.name ? tr.card.name : "Not Available" }}
                </p>
              </vs-td>
              <vs-td class="center" @click.native.stop="reviewData(tr)">
                <p class="font-medium">
                  {{
                    tr.bonus_amount
                      ? tr.bonus_amount.toLocaleString()
                      : "Not Available"
                  }}
                </p>
              </vs-td>
              <vs-td
                class="img-container center"
                @click.native.stop="reviewData(tr)"
              >
                <vue-load-image>
                  <img
                    v-if="tr.emoji == 'diamond.png'"
                    slot="image"
                    :src="require('@/assets/images/emoji/' + tr.emoji)"
                    height="20.47"
                    width="22.89"
                  />
                  <img
                    v-if="tr.emoji == 'unicorn.png'"
                    slot="image"
                    :src="require('@/assets/images/emoji/' + tr.emoji)"
                    height="21.36"
                    width="22.65"
                  />
                  <img
                    v-if="tr.emoji == 'fire.png'"
                    slot="image"
                    :src="require('@/assets/images/emoji/' + tr.emoji)"
                    height="24.43"
                    width="18.91"
                  />
                </vue-load-image>
              </vs-td>

              <vs-td class="centerdate" @click.native.stop="reviewData(tr)">
                <p v-if="tr.expiration_date" class="font-medium">
                  {{ tr.expiration_date | formatDate }}
                </p>
                <p v-else class="font-medium">
                  {{ "N/A" }}
                </p>
              </vs-td>

              <vs-td class="centerdate" @click.native.stop="reviewData(tr)">
                <p v-if="tr.hide_from_dashboard" class="font-medium">
                  {{ tr.hide_from_dashboard | capitalize }}
                </p>
                <p v-else class="font-medium">
                  {{ "FALSE" }}
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <vs-row
        class="my-6 w-full"
        vs-justify="center"
        v-if="offersCardsList && offersCardsList.length > 0"
      >
        <div style="width: max-content">
          <vs-pagination
            :total="totalPages"
            v-model="pageIndex"
            @change="getOfferCards"
            v-show="cardListHasData"
          ></vs-pagination>
        </div>
      </vs-row>
    </vs-row>
    <vs-popup
      class="holamundo"
      title="Status"
      :active.sync="showDeleteStatus.status"
    >
      <h5>
        {{ showDeleteStatus.msg }}
      </h5>
    </vs-popup>
    <vs-popup class="holamundo" title="Status" :active.sync="offerIds.status">
      <h5>
        {{ offerIds.msg }}
      </h5>
    </vs-popup>
    <vs-popup class="holamundo" title="Status" :active.sync="confirmDelete">
      <h5>Are you sure that you want to delete?</h5>
      <vs-row vs-justify="flex-end">
        <vs-button @click="deleteOffers" class="mr-4">Yes</vs-button>
        <vs-button @click="confirmDelete = false">No</vs-button>
      </vs-row>
    </vs-popup>
  </vs-row>
</template>

<script>
import { MenuIcon, XIcon } from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";

import { validateIssuerName, validateCardName } from "@/views/admin/validation";
import { genericErrorMessage, toast } from "@/keys/toast-messages";
import VueLoadImage from "vue-load-image";

import EventBus from "@/event-bus.js";

export default {
  components: {
    MenuIcon,
    XIcon,
    VueLoadImage,
  },
  mixins: [clickaway],
  data() {
    return {
      timer: false,
      confirmDelete: false,
      cardsList: [],

      actionBtnClr: "#1D2024",
      offersCardsList: [],
      search: "",

      cardListHasData: true,
      pageIndex: 1,
      totalPages: 1,

      selected: [],
      itemsPerPage: 10,

      showDeleteStatus: {
        msg: "",
        status: false,
      },

      offerIds: {
        msg: "",
        success: false,
      },
      errors: {
        cardName: {
          msg: "",
          success: false,
        },
      },
      genericErrorMessage,
      toast,
      datatoedit: "",
      isdelete: "",
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  methods: {
    async addNewData() {
      await this.$router.push({
        name: "add-offer",
        params: {
          pagename: "Add Offer",
        },

        //path:"/offers/add-offer"
      });
    },
    async reviewData(data) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.selected = [];
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise(async (resolve, reject) => {
          await this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.OfferInfo, {
              params: {
                offerId: data._id,
              },
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            })
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                this.$root.$emit("updateApprovals", {});
                resolve(
                  //console.log(res.data)
                  (this.datatoedit = res.data.data)
                );
                await this.$router.push({
                  name: "offer-details",
                  params: {
                    data: this.datatoedit,
                    pagename: "Offer Details",
                  },
                });
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              //console.log(e,"list");
              if (e.response.status == 404) {
                this.datatoedit = "";
              }
              if (e.response.status !== 401 && e.response.status !== 404) {
                this.toast(this.genericErrorMessage());
              }
            });
        });
      }, 500);
    },

    async getOfferCards(name) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        //this.selected = [];
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        if (
          this.isdelete &&
          this.offersCardsList.length == this.selected.length &&
          this.pageIndex > 1
        ) {
          this.pageIndex -= 1;
        }
        this.selected = [];
        return new Promise(async (resolve, reject) => {
          await this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.ViewOffers, {
              params: {
                searchquery: this.search,
                page: name == "search" ? 1 : this.pageIndex,
                limit: this.itemsPerPage,
              },
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            })
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                this.$root.$emit("updateApprovals", {});
                if (name == "search") {
                  this.pageIndex = 1;
                }
                this.totalPages = res.data.pageCount;
                resolve(
                  //console.log(res.data)
                  (this.offersCardsList = res.data.data),
                  (this.cardListHasData = true)
                );

                for (var key in this.offersCardsList) {
                  if (this.offersCardsList[key].emoji) {
                    var a = this.offersCardsList[key].emoji.split(".");
                    if (a[1] != "png") {
                      this.offersCardsList[key].emoji =
                        this.offersCardsList[key].emoji + ".png";
                    }
                  }
                }
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.status == 404) {
                this.cardListHasData = false;
                this.offersCardsList = [];
              }
              if (e.response.status !== 401 && e.response.status !== 404) {
                this.toast(this.genericErrorMessage());
              }
            });
        });
      }, 500);
    },

    getOffers(input) {},

    async deleteOffers() {
      this.confirmDelete = false;
      if (this.selected.length == 0) {
        this.showDeleteStatus = {
          msg: "Please select atleast one card to delete",
          status: true,
        };
      } else {
        this.showDeleteStatus = {
          msg: "",
          status: false,
        };
        let offerId = [];

        await this.selected.forEach(async function (item, index) {
          offerId.push(item._id);
        });
        //console.log(offerId);
        this.timer = setTimeout(() => {
          this.$vs.loading.close();
          this.$vs.loading({
            background: "rgba(1,2,3,.2)",
          });
          return new Promise((resolve, reject) => {
            this.$axios
              .post(
                this.$ApiKeys.BASE_URL + this.$EndPoints.DeleteOffers,
                {
                  offerIds: JSON.stringify(offerId),
                },
                {
                  headers: {
                    Authorization: this.$localStorage.get("token"),
                  },
                }
              )
              .then(async (res) => {
                this.$vs.loading.close();
                if (res.data.success == true) {
                  this.showDeleteStatus = {
                    msg: res.data.data.message,
                    status: true,
                  };
                  this.isdelete = true;
                  this.getOfferCards();
                } else {
                  this.toast(this.genericErrorMessage());
                }
              })
              .catch((e) => {
                this.$vs.loading.close();
                if (e.response.data.errors && e.response.data.errors.offerIds) {
                  this.offerIds = {
                    msg: e.response.data.errors.offerIds,
                    status: true,
                  };
                } else {
                  this.offerIds = {
                    msg: "",
                    status: false,
                  };
                }

                if (
                  !e.response.data.errors &&
                  !e.response.data.errors.offerIds
                ) {
                  if (e.response.status !== 401) {
                    this.toast(this.genericErrorMessage());
                  }
                }
              });
          });
        }, 500);
      }
    },
  },
  created() {
    EventBus.$emit("resetToggleGroup", true);
    this.getOfferCards();
  },
};
</script>

<style>
@import "./style.css";
</style>
